<ng-container >
    <h6 class="mb-1">Verifying...</h6>
    <div>You will be redirected to Log In screen once the verification is complete.</div>
  </ng-container>
  